<template>
  <footer class="footer">
    <div class="text-footer">
      {{ $t("layout.footer.poweredBy") }}
    </div>
    <div class="container-fluid">
    <a
      href="http://www.linkconsulting.com/"
      target="_blank"
      rel="noopener"
      ><img class="image" src="../../assets/img/link_blue.png"></a
    >
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
.image{
  height: 35px;
  margin: auto !important;  
  display: block !important;
}
.container-fluid{
  position: relative;
  bottom:-140px !important;  
  justify-content: center !important;  
}
.text-footer{
  font-family: "Montserrat";
  color: #009EBA !important;
  position: relative;
  bottom: -140px !important;  
  text-align: center;
}
.main-panel > .welcome-content-footer {
  padding: 30px 0px 30px 0px !important;
  height: 50px;
}
</style>
